module.exports = __webpack_public_path__ + "media/assets/icons/income_protection_icon-bce28adae3e6fd1ee369b03f5fb2df13.svg";